export default __webpack_public_path__ + "static/media/goalCard.7debc722.svg";